import React from "react";
import "../../assets/styles/components/textfield.scss";
import { Row, Col, Alert, message, Form, Input, Button, Checkbox } from "antd";

interface Props {
  placeholder?: string;
  width?: number;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  name?: string;
  rules?: any;
  label?: string;
  isPassword?: boolean;
}

const TextField: React.FC<Props> = ({
  placeholder,
  onChange,
  width = "100",
  name,
  label = "",
  rules = [],
  isPassword = false,
}) => {
  return (
    <div className="text-field">
      {/* <input
        placeholder={placeholder}
        onChange={onChange}
        style={{ width: `${width}px` }}
      /> */}
      <Form.Item
        name={name}
        label={label}
        // rules={[{ required: true, message: "กรุณาป้อนชื่อผู้ใช้!" }]}
        rules={rules}
      >
        <Input
          // prefix={<UserOutlined className="site-form-item-icon" />}
          placeholder={placeholder}
          onChange={onChange}
          style={{ width: `${width}px` }}
          type={isPassword ? "password" : "text"}
        />
      </Form.Item>
    </div>
  );
};
export default TextField;
